export default "__VITE_ASSET__RJVXNMmj__"